import React from 'react';
import PropTypes from 'prop-types';

import Booking from 'models/booking';
import { Location } from 'models/locations';
import Brand from 'models/brand';

import BookAgain from 'components/location/buttons/book-again';

const propTypes = {
  booking: PropTypes.instanceOf(Booking).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  brand: PropTypes.instanceOf(Brand).isRequired,
  selected: PropTypes.bool,
};

const defaultProps = {
  selected: false,
};

const PastBookingInfoAction = ({ selected, booking, location, brand }) => {
  if (booking.onDemand) {
    return (
      <div className="text-weight-book text-size-10 text-color-dark-slatetext-color-dark-slate margin-top-10">
        View Details in App
      </div>
    );
  }

  if (!selected) {
    return <BookAgain location={location} venueID={booking.venueId} brand={brand} booking={booking} />;
  }

  return null;
};

PastBookingInfoAction.propTypes = propTypes;
PastBookingInfoAction.defaultProps = defaultProps;
export default PastBookingInfoAction;
